import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import flatMap from 'lodash/flatMap';
import values from 'lodash/values';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { themesMixin } from '../../../utils/themes';
export default {
  name: 'NiotaClassicApplicationsCsvExport',
  mixins: [themesMixin],
  props: {
    applicationId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    var start = new Date(new Date() - 86400000 * 2);
    var end = new Date();
    return {
      start: start,
      end: end,
      exportQuery: {
        applicationId: this.applicationId,
        time: {
          from: start,
          to: end
        },
        outputType: 'one-file-per-device-variable'
      },
      exportVariables: [],
      variables: [],
      variablesIsUpdating: true,
      formValid: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    backgroundColor: function backgroundColor() {
      return "background-color: ".concat(this.vuetifyColorHex('info'));
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    borderColor: function borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    }
  }),
  watch: {},
  created: function created() {
    this.fetchVariables();
  },
  methods: {
    datePicked: function datePicked(dateObject) {
      this.start = new Date(dateObject.from * 1000);
      this.end = new Date(dateObject.to * 1000);
      this.exportQuery = _objectSpread(_objectSpread({}, this.exportQuery), {}, {
        time: {
          from: this.start,
          to: this.end
        }
      });
    },
    variablesChanged: function variablesChanged() {
      this.exportQuery = _objectSpread(_objectSpread({}, this.exportQuery), {}, {
        variables: this.exportVariables
      });
      this.formValid = !!this.exportVariables.length;
    },
    fetchVariables: function () {
      var _fetchVariables = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var devices, variables;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.variablesIsUpdating = true;
                _context.next = 3;
                return NiotaClassicApiService.getApplicationDevicesPlain(this.applicationId).then(function (res) {
                  return res.data.devices;
                }).catch(function (error) {
                  console.error({
                    error: error
                  });

                  _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.errorLoadingParsedPackets'), 'error');
                });

              case 3:
                devices = _context.sent;
                variables = flatMap(devices, function (device) {
                  var parserVariables = [];

                  if (get(device, 'deviceType.parser.type') === 'multi') {
                    parserVariables = flatMap(get(device, 'deviceType.parser.config'), function (config, name) {
                      return values(name === '__switch' ? {} : get(config, 'variables', {}));
                    });
                  } else {
                    parserVariables = get(device, 'deviceType.parser.config.variables');
                  }

                  if (!parserVariables) {
                    return [];
                  }

                  return flatMap(parserVariables, function (parserVariable) {
                    var measurement = get(parserVariable, 'value_type.base_unit');
                    var name = parserVariable.name;

                    if (!measurement) {
                      return [];
                    }

                    return {
                      label: "".concat(name, " (").concat(measurement, ")"),
                      variable: name,
                      measurement: measurement
                    };
                  });
                });
                this.variables = sortBy(uniqBy(variables, 'label'), 'label');
                this.variablesIsUpdating = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchVariables() {
        return _fetchVariables.apply(this, arguments);
      }

      return fetchVariables;
    }()
  }
};